const { navMobile } = require("./modules/nav-mobile");
const { desktopLevelMenuHelper } = require("./modules/desktop-level-menu-helper");
const { megamenuInit } = require("./modules/nav-megamenu");
const { slideMenu } = require("./modules/slide-menu");
const { navScrollMenu } = require("./modules/nav-scrollMenu");
const { popup } = require("./modules/popup");
const { lightBoxInit } = require("./modules/lightbox");
const { backgroundVideoInit } = require("./modules/background-video");
const { scrollFlag } = require("./modules/nav-scrollFlag");
const { accessibilityWidget } = require("./modules/accessibility-widget");
const { infiniteRollAnimation } = require("./modules/infinite-roll-animation");
const { footerAccordion } = require("./modules/footer-accordion");
const { contactFormAcceptance } = require("./modules/contact-form-acceptance");
const { contactFormFiles } = require("./modules/contact-form-files");
const { tableOfContents } = require("./modules/table-of-contents");
const { searchOverlay } = require("./modules/search-overlay");
const { postVideoLightbox } = require("./modules/post-video-lightbox");
const { rowShowMore } = require("./modules/row-show-more");
const { shareCopyLink } = require("./modules/share-copy-link");

const AOS = require("./../external/aos.js");

document.addEventListener("DOMContentLoaded", () => {
    accessibilityWidget();
    AOS.init({
        offset: 60, // offset (in px) from the original trigger point
        duration: 1200,
        once: true
    });
    scrollFlag();
    navMobile();
    desktopLevelMenuHelper();
    megamenuInit();
    slideMenu();
    navScrollMenu();
    backgroundVideoInit();
    popup();
    lightBoxInit();
    infiniteRollAnimation();
    footerAccordion();
    contactFormAcceptance();
    contactFormFiles();
    tableOfContents();
    searchOverlay();
    postVideoLightbox();
    rowShowMore();
    shareCopyLink();

    window.addEventListener("scroll", () => {
        scrollFlag();
    });

    window.addEventListener("resize", () => {
        backgroundVideoInit();
    });
});
